import React from 'react';
import { Eyebrow } from './Eyebrow';
import { Reveal } from './Reveal';
const steps = [{
  day: 'DÍA 1',
  text: 'Lo sumás a tu desayuno de la mañana, sin agregar pasos.'
}, {
  day: 'DÍA 7',
  text: 'Ya no pensás si lo vas a tomar. Es parte de tu desayuno de siempre.'
}, {
  day: 'DÍA 30',
  text: 'Sumaste proteína todos los días, sin agregar un paso a tu rutina.'
}, {
  day: 'DÍA 90',
  text: 'Es, simplemente, parte de tu rutina.'
}];
export function Timeline() {
  return <section className="border-b border-white/[0.16] bg-espresso py-[88px]" data-id="element-135">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-136">
        <Reveal data-id="element-137">
          <Eyebrow data-id="element-138">TODO EN UNO</Eyebrow>
        </Reveal>
        <Reveal data-id="element-139">
          <h2 className="max-w-[480px] text-[clamp(24px,3.6vw,36px)] leading-[1.1] text-white" data-id="element-140">
            CÓMO SE METE EN TU RUTINA, SIN QUE LA NOTES.
          </h2>
        </Reveal>
        <div className="relative mt-[46px] grid grid-cols-1 gap-7 md:grid-cols-4 md:gap-0 md:before:absolute md:before:left-0 md:before:right-0 md:before:top-[11px] md:before:h-px md:before:bg-white/[0.16] md:before:content-['']" data-id="element-141">
          {steps.map((step, i) => <Reveal key={step.day} delay={i * 0.08} className="relative pt-[30px] md:pr-[18px]" data-id="element-142">
              <div className="absolute left-0 top-[5px] h-[13px] w-[13px] border-[3px] border-espresso bg-camel" data-id="element-143" />
              <div className="mb-2 font-display text-base tracking-[1px] text-camel-light" data-id="element-144">
                {step.day}
              </div>
              <p className="max-w-[230px] text-[14.5px] font-semibold text-white/80" data-id="element-145">
                {step.text}
              </p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}